import { render } from "./dialog-unpay-record.vue?vue&type=template&id=0fddd7f6&scoped=true"
import script from "./dialog-unpay-record.vue?vue&type=script&lang=js"
export * from "./dialog-unpay-record.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fddd7f6"]])

export default __exports__